<template>
  <div id="basicInfo">
    <!-- 分销商 -->
    <div class="header">
      <div class="operation-btns">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="getChannelDailyStatistics"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </div>
      <div class="filters">
        <el-select
          v-model="query.organizationUnitId"
          @change="getChannelDailyStatistics"
          filterable
          remote
          :remote-method="remoteMethod"
          @clear="clear"
          placeholder="请输入渠道部门名称"
          class="handle-select"
          clearable
        >
          <el-option
            v-for="item in orgList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button class="updown" plain @click="exportStatistics"
          >导出</el-button
        >
      </div>
    </div>
    <div class="main" ref="main">
      <el-table
        :data="settingsData"
        border
        show-summary
        :summary-method="getSummaries"
        @cell-click="cellClick"
        :max-height="maxHeight"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="channelName"
          label="渠道人员"
          show-overflow-tooltip
          align="center"
          min-width="110"
          :resizable="false"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.channelName | nullValue }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reservationCount"
          label="当日报备"
          min-width="110"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.reservationCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="visitCount"
          label="当日带看"
          min-width="110"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.visitCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recognitionCount"
          label="当日认购"
          align="center"
          min-width="110"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.recognitionCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="netSignCount"
          label="当日网签"
          min-width="110"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.netSignCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="当日结佣"
          sortable
          min-width="110"
          align="center"
          prop="commissionCount"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.commissionCount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="当日退订"
          align="center"
          min-width="110"
          sortable
          prop="refundCount"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.refundCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="storeCount"
          label="当日新增分销商门店"
          align="center"
          min-width="175"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.storeCount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="brokerCount"
          label="当日新增经纪人"
          min-width="150"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.brokerCount }}
            </span>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingsData.length">
            列表为空
          </div>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getChannelDailyStatistics,
  getExportChannelDailyStatistics,
} from "@/http/api/report";
import { dateFormat } from "@/common/filters";
import { getOrgsSearch } from "@/http/api/organization";
import { deepCopy } from "@/utils/deepCopy";
export default {
  data() {
    return {
      daterange: [
        new Date(new Date(new Date().toLocaleDateString()).getTime()),
        new Date(),
      ],
      query: {
        organizationUnitId: "",
        startTime: dateFormat(
          new Date(new Date(new Date().toLocaleDateString()).getTime())
        ),
        endTime: dateFormat(new Date()),
      },
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() >
            new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                86400 * 1000 -
                1
            )
          );
        },
      },
      settingsData: [],
      orgList:[],
      maxHeight:0,
      isLoading: true,
      permissions: {},
    };
  },
  mounted() {
    this.permissions = this.$store.getters.permissions;
    this.getTableHeight();
    this.getChannelDailyStatistics();
  },
  methods: {
    getTableHeight () {
      this.$nextTick(() => {
        const rect = this.$refs.main.getBoundingClientRect()
        this.maxHeight = rect.height;
      })
    },
    cellClick(row, column){
      if (column.label!='当日结佣'&&column.label!='新增分销商门店'&&column.label!='新增经纪人'&&column.label!='渠道人员'&&column.label) {
        if (this.permissions["Reservation"]) {
          let query={
            channelId:row.channelId,
            channelName:row.channelName
          }
          switch (column.label) {
            case '当日报备':
              query.flowStatus='reservation'
              break;
            case '当日带看':
              query.flowStatus='visit'
              break;
            case '当日认购':
              query.flowStatus='recognition'
              break;
            case '当日网签':
              query.flowStatus='netSign'
              break;
          }
          if (this.daterange&&this.daterange.length) {
            query.startTime = dateFormat(this.daterange[0]);
            query.endTime = dateFormat(this.daterange[1]);
          }
          let strItem = JSON.stringify(query);
          this.$router.push({
            name:'reservationList',
            params:{
              obj:strItem,
            }
          });
        }else{
          this.$message.warning({
            message: "您暂无查看报备列表权限",
            showClose: true,
          });
        }
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "channelName") {
          sums[index] = "—";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property !== "channelName") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index];
        }
      });
      return sums;
    },
    getChannelDailyStatistics() {
      this.isLoading = true;
      this.query.startTime = dateFormat(this.daterange[0]);
      this.query.endTime = dateFormat(this.daterange[1]);
      let query = deepCopy(this.query);
      this.settingsData=[];
      getChannelDailyStatistics(query).then((res) => {
        if (res.code == 10200) {
          this.settingsData = res.result.items;
          this.isLoading = false;
        }this.isLoading = false;
      }).catch(err=>{
          this.isLoading = false;
      });
    },
    exportStatistics() {
      this.query.startTime = dateFormat(this.daterange[0]);
      this.query.endTime = dateFormat(this.daterange[1]);
      let query = deepCopy(this.query);
      getExportChannelDailyStatistics(query).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = "智能报表-渠道统计.xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "智能报表-渠道统计.xlsx");
        }
      });
    },
    remoteMethod(query) {
      if (query) {
        this.searchFilter = query;
        this.getOrgsSearch();
      }else{
        this.orgList=[]
      }
    },
    clear() {
      this.searchFilter = "";
      this.orgList=[];
    },
    // 获取分销商门店列表
    getOrgsSearch() {
      let query = { filter: "" };
      if (this.searchFilter) {
        query.filter = this.searchFilter;
      } else {
        delete query.filter;
      }
      getOrgsSearch(query).then((res) => {
        console.log("获取分销商：", res);
        this.orgList = res.result.items;
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#basicInfo {
  .header {
    @include flex(row, center);
    justify-content: space-between;
    margin-bottom: 20px;
    border-radius: $--border-radius-base;
    .operation-btns,
    .filters {
      @include flex(row, center);
      .el-select {
        width: 200px;
        margin-left: 5px;
      }
      .input-with-select {
        width: 400px;
        .el-select {
          width: 110px;
        }
      }
      .updown {
        margin-left: 5px;
      }
    }
  }
  .main{
    height: calc(100vh - 210px);
  }
  .pointer{
    cursor: pointer;
  }
}
</style>
